import HelpMain from './modules/help/helpMain';
function bootHelpPage() {
    if (!document.getElementById('operate-goods')) {
        return;
    }
    if (typeof guideCategories === 'undefined') {
        console.error('[help] guideCategories 未定义，请检查 help.html 内联数据脚本');
        return;
    }
    new HelpMain();
}
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootHelpPage);
}
else {
    bootHelpPage();
}
